import { render } from "./BaseTextArea.vue?vue&type=template&id=84d4d42c"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"
script.render = render

export default script